'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.purchaseOnEnterSaga = purchaseOnEnterSaga;

var _effects = require('redux-saga/effects');

var _sagaTools = require('@classpass/saga-tools');

var _bound = require('redux/saga/entities/bound');

var _selectors = require('redux/saga/selectors');

var _helpers = require('redux/saga/helpers');

var _requireMembershipStatus = require('routes/helpers/requireMembershipStatus');

var _requireMembershipStatus2 = _interopRequireDefault(_requireMembershipStatus);

var _memberStatus = require('enums/memberStatus');

var _Base = require('derivers/Base64');

var _Base2 = _interopRequireDefault(_Base);

var _msas = require('constants/msas');

var _PhoneVerification = require('features/PhoneVerification/PhoneVerification.saga');

var _Plan = require('derivers/Plan');

var _Plan2 = _interopRequireDefault(_Plan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(purchaseOnEnterSaga);

// redirects to the signup URL for this item if you are not logged in
// or redirects to / if you already have a subscription
function purchaseOnEnterSaga(client, nextState, replaceState) {
  var loggedIn, isLive, userStatus, msa, msaId, livePlans, id, plan, verificationRequired;
  return _regenerator2.default.wrap(function purchaseOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 2:
          loggedIn = _context.sent;
          isLive = /\/purchase\/live($|\/)/.test(nextState.location.pathname);

          if (loggedIn) {
            _context.next = 8;
            break;
          }

          _context.next = 7;
          return (0, _effects.call)(replaceState, (0, _extends3.default)({}, nextState.location, {
            pathname: nextState.location.pathname.replace(/^\/purchase/, '/signup')
          }));

        case 7:
          return _context.abrupt('return', _context.sent);

        case 8:
          _context.next = 10;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 10:
          _context.next = 12;
          return (0, _effects.select)(_selectors.memberStatus);

        case 12:
          userStatus = _context.sent;

          if (!isLive) {
            _context.next = 33;
            break;
          }

          _context.next = 16;
          return (0, _effects.call)(_helpers.scrollToTop);

        case 16:
          if (!(0, _memberStatus.memberStatus)('ACTIVE', userStatus)) {
            _context.next = 31;
            break;
          }

          _context.next = 19;
          return (0, _effects.call)(_helpers.geodetectMsa, client);

        case 19:
          msa = _context.sent;
          msaId = msa ? msa.id : _msas.LIVE_DEFAULT_MSA;
          _context.next = 23;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.livePlansByMsa, [client, msaId]);

        case 23:
          livePlans = _context.sent;
          id = _Base2.default.decodeNumber(nextState.params.encodedLivePlanId);
          plan = livePlans.find(function (p) {
            return p.planId === id;
          });
          _context.next = 28;
          return (0, _effects.call)(replaceState, (0, _extends3.default)({}, nextState.location, {
            pathname: '/settings/live/' + (_Plan2.default.isLiveTrial(plan) ? 'trial' : 'plans')
          }));

        case 28:
          return _context.abrupt('return', _context.sent);

        case 31:
          if (!(0, _memberStatus.memberStatus)('CANCELLED', userStatus)) {
            _context.next = 33;
            break;
          }

          return _context.abrupt('return');

        case 33:
          _context.next = 35;
          return (0, _effects.call)(_PhoneVerification.userNeedsPhoneVerification, client);

        case 35:
          verificationRequired = _context.sent;

          if (!verificationRequired) {
            _context.next = 40;
            break;
          }

          _context.next = 39;
          return (0, _effects.call)(replaceState, (0, _extends3.default)({}, nextState.location, {
            pathname: nextState.location.pathname.replace(/^\/purchase/, '/verify-phone')
          }));

        case 39:
          return _context.abrupt('return', _context.sent);

        case 40:
          _context.next = 42;
          return (0, _effects.call)(_requireMembershipStatus2.default, client, replaceState, [(0, _memberStatus.memberStatus)('UNSUBSCRIBED')]);

        case 42:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}